// Google Analytics 4 Integration
// Tracks page views, unique visitors, and events

// Initialize GA4
export const initGA = (measurementId) => {
  if (typeof window === 'undefined') return;
  
  // Check if GA script is already loaded
  if (window.gtag) {
    console.log('✅ Google Analytics already initialized');
    return;
  }

  // Load GA4 script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: true
  });

  console.log('✅ Google Analytics initialized:', measurementId);
};

// Track page view
export const trackPageView = (path) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title
  });
  
  console.log('📊 Page view tracked:', path);
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  
  window.gtag('event', eventName, eventParams);
  console.log('📊 Event tracked:', eventName, eventParams);
};

// Track search
export const trackSearch = (searchParams) => {
  trackEvent('search', {
    search_origin: searchParams.origin,
    search_destination: searchParams.destination,
    search_date: searchParams.departureDate,
    search_passengers: searchParams.passengers,
    search_class: searchParams.travelClass
  });
};

// Track flight booking click
export const trackBookingClick = (flight, provider) => {
  trackEvent('booking_click', {
    flight_price: flight.price,
    flight_airline: flight.airline,
    flight_origin: flight.from,
    flight_destination: flight.to,
    booking_provider: provider
  });
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackSearch,
  trackBookingClick
};
